import { PageOption, pageOptions, PrintOptions as printOptions } from '../../services/helpers';
import * as _ from 'lodash';

// Copy/Paste from printDashbaordState
export function getDefaultPrintOptions(orientation?: string, format?: string): printOptions {
    const config = getConfigFromUrl(orientation, format);
    return (config) ? config.configuration : pageOptions[0].configuration;
}

function getConfigFromUrl(orientation?: string, format?: string): PageOption {
    let config: PageOption;
    if (orientation && format) {
        config = _.find(pageOptions, o =>
            o.configuration.orientation === parseInt(orientation)
            && (o.configuration as any).format === parseInt(format)
        );
    }
    return config;
}